var exports = {
  "k": "xfb577c5e--e00940--container",
  "K": "xfb577c5e--e00940--icon",
};

module.exports = exports;
